import {writable} from 'svelte/store';

let userObject = {
    cloud_key: null,
    id: null,
    name: null,
    company: null,
    // token: null,
};

const {get, set, update, subscribe} = writable(userObject);

const user = {
    set,
    update,
    subscribe,

    getCloudKey: () => {
        return userObject.cloud_key || '';
    },

    acronym : () => {
        if (!userObject.name) {
            return '';
        }
        return userObject.name.split(' ').map(function(item){return item[0]}).join('');
    },

    // initialize: () => {
    //     user.update(obj => {
    //         obj.token = cookie.get('analytikoncloud') || null;
    //         return obj;
    //     });
    // },
    //
    // setUser: data => {
    //     user.update(obj => {
    //         obj.id = data.id;
    //         obj.name = data.name;
    //         obj.email = data.email;
    //         obj.token = data.token;
    //         obj.role = ~~data.role;
    //         user.saveCookie();
    //         return obj;
    //     });
    // },
    //
    //
    // isAdmin: () => {
    //     return userObject.role == USER_ROLE.ADMIN;
    // }
}

export default user;